import html from './assets/html.svg';
import css from './assets/css3.svg';
import tailwind from './assets/tailwind.svg';
import js from './assets/javascript.svg';
import react from './assets/reactjs.svg';
import angular from './assets/angular.svg';
import vue from './assets/vuejs.svg';
import nodejs from './assets/nodejs.svg';
import git from './assets/git.svg';
import github from './assets/github.svg';

export const TECHNOLOGIES = [
  'HTML',
  'CSS',
  'Tailwind CSS',
  'JavaScript',
  'React JS',
  'Angular',
  'Vue JS',
  'Node JS',
  'Git',
  'GitHub',
];

export const IMAGE_URLS = [html, css, tailwind, js, react, angular, vue, nodejs, git, github];
